import { ChapterBookmark } from '@/types/types';
import useBookmark from '../useBookmark';
import type { Course, Enum_Bookmark_Category, Resource } from '@edwin-group/cj-graphql/generated/graphql';

interface BookmarkButtonProps {
  relationId: string;
  metadata: Resource | Course | ChapterBookmark | null;
  typeId?: string;
  category: Enum_Bookmark_Category;
  onRemoveFromBookmark?: () => void;
}

export default function BookmarkButton({
  relationId,
  metadata,
  typeId,
  category,
  onRemoveFromBookmark,
}: BookmarkButtonProps) {
  const { exist, handleClick } = useBookmark({ relationId });

  const fill = exist ? '#000' : 'none';

  return (
    <button
      aria-label="Bookmark"
      className="cursor-pointer border-none bg-none p-0"
      onClick={async (e) => {
        e.preventDefault();
        await handleClick(metadata, typeId, category, onRemoveFromBookmark);
      }}>
      <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.77639 10.3741L0.5 12.0123V1.62136C0.5 1.32962 0.615893 1.04983 0.822182 0.843545C1.02847 0.637255 1.30826 0.521362 1.6 0.521362H6.4C6.69174 0.521362 6.97153 0.637255 7.17782 0.843545C7.38411 1.04983 7.5 1.32962 7.5 1.62136V12.0123L4.22361 10.3741L4 10.2623L3.77639 10.3741Z"
          fill={fill}
          stroke="black"
        />
      </svg>
    </button>
  );
}
